import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const LanguageSelectPage = ({ onLanguageSelect }) => {
  const { setLanguage } = useLanguage();

  const languages = [
    { code: 'it', name: 'Italiano', flag: '🇮🇹', native: 'Italiano' },
    { code: 'en', name: 'English', flag: '🇬🇧', native: 'English' },
    { code: 'pl', name: 'Polski', flag: '🇵🇱', native: 'Polski' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪', native: 'Deutsch' },
  ];

  const handleSelectLanguage = (code) => {
    setLanguage(code);
    localStorage.setItem('automat_language_selected', 'true');
    onLanguageSelect();
  };

  return (
    <div 
      className="min-h-screen bg-slate-900 flex items-center justify-center p-4"
      data-testid="language-select-page"
    >
      <div className="max-w-md w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-white rounded-lg flex items-center justify-center mx-auto mb-4 shadow-xl">
            <span className="text-orange-500 font-bold text-4xl" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>A</span>
          </div>
          <h1 
            className="text-3xl font-bold text-white tracking-tight"
            style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
          >
            AUTOMAT.IO
          </h1>
          <p className="text-slate-400 mt-2">Industrial Automation Network</p>
        </div>

        {/* Language Selection */}
        <Card className="border-0 shadow-2xl">
          <CardContent className="p-6">
            <h2 className="text-center text-lg font-semibold text-slate-700 mb-6">
              Seleziona la lingua / Select language / Wybierz język / Sprache wählen
            </h2>
            
            <div className="space-y-3">
              {languages.map((lang) => (
                <Button
                  key={lang.code}
                  variant="outline"
                  className="w-full h-16 justify-start gap-4 text-lg hover:bg-orange-50 hover:border-orange-500 transition-all rounded-md"
                  onClick={() => handleSelectLanguage(lang.code)}
                  data-testid={`select-lang-${lang.code}`}
                >
                  <span className="text-3xl">{lang.flag}</span>
                  <div className="text-left">
                    <p className="font-semibold text-slate-900">{lang.native}</p>
                    <p className="text-sm text-slate-500">{lang.name}</p>
                  </div>
                </Button>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Price info */}
        <div className="mt-6 text-center">
          <p className="text-slate-400 text-sm">
            <span className="text-emerald-400 font-semibold">✓ Registrazione gratuita</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelectPage;
